import getApiClient from '@/plugins/api-client'
import planPeriodicities from '@/util/planPeriodicities'
import { parseFilters } from '@/util/helpers'

export default {
  loadSubscriptions () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
      ...this.filters,
      ...this.pagination.getParams(),
    })

    api.get('subscriptions', { params })
      .then(result => {
        this.subscriptions = result.data['hydra:member']
        this.pagination.updateData(result.data)
      })
      .catch(error => {
        this.error = error
      })
  },

  getPlanPeriodicityLabel (periodicity) {
    return planPeriodicities.filter(item => {
      return item.code === periodicity
    })[0]?.label
  },

  clearFilters () {
    this.filters = {}
    if (this.$route.params.email) {
      this.$route.params.email = null
      this.$route.params.plan = null
      this.$router.push(this.$route)
    } else {
      this.loadSubscriptions()
    }
  },

  searchPlans (query) {
    const api = getApiClient(this.$store)

    const params = {
      name: query,
    }

    api.get('plans', { params })
      .then(result => {
        this.plansList = result.data['hydra:member']
      })
      .catch(() => {
        return false
      })
  },

  exportSubscriptions: function () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
        ...this.filters,
      },
    )

    api.get('subscription_reports/export', { params }, { responseType: 'blob' })
      .then(result => {
        const url = window.URL.createObjectURL(new Blob([result.data]))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', 'export.csv')
        document.body.appendChild(link)
        link.click()
      })
      .catch(error => {
        console.log(error)
      })
  },

  exportDetailedSubscriptions: function () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
        ...this.filters,
      },
    )

    api.get('subscriptions/export', { params }, { responseType: 'blob' })
      .then(result => {
        const url = window.URL.createObjectURL(new Blob([result.data]))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', 'export.csv')
        document.body.appendChild(link)
        link.click()
      })
      .catch(error => {
        console.log(error)
      })
  },
}
